module.exports = __webpack_public_path__ + "static/media/man-behind-bg.ae4ac984.png";